<template>
  <section>
    <div class="toolbar">
      <div>
        <h1>审核日志</h1>
        <p>记录小程序端每一次审核操作（内容、轮次、审核人、前后状态、驳回原因），只新增不覆盖。</p>
      </div>
      <el-button icon="el-icon-refresh" @click="reload">刷新</el-button>
    </div>

    <div class="filters">
      <el-select v-model="query.type" clearable placeholder="内容类型" style="width:150px" @change="reload">
        <el-option label="全部类型" value="all" />
        <el-option label="闲置商品" value="goods" />
        <el-option label="邻里需求" value="demand" />
        <el-option label="邻里服务" value="service" />
      </el-select>
      <el-select v-model="query.result" clearable placeholder="审核结果" style="width:140px" @change="reload">
        <el-option label="全部结果" value="all" />
        <el-option label="通过" value="approve" />
        <el-option label="驳回" value="reject" />
      </el-select>
      <el-select v-model="query.reviewerId" clearable placeholder="审核人" style="width:180px" @change="reload">
        <el-option v-for="r in reviewerOptions" :key="r.reviewerId" :value="r.reviewerId"
          :label="`${r.reviewerName || '未填写'} ${r.reviewerPhone || ''}（${r.total}）`" />
      </el-select>
      <el-date-picker v-model="range" type="daterange" unlink-panels value-format="yyyy-MM-dd"
        start-placeholder="开始日期" end-placeholder="结束日期" style="width:250px" @change="onRangeChange" />
      <el-input v-model="query.keyword" clearable placeholder="内容标题 / 审核人手机号" style="width:220px"
        @keyup.enter.native="reload" @clear="reload" />
      <el-button type="primary" icon="el-icon-search" @click="reload">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table v-loading="loading" :data="rows" border stripe>
      <el-table-column label="审核时间" width="165">
        <template slot-scope="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="内容" min-width="200">
        <template slot-scope="s">
          <div class="cell-title">{{ s.row.contentTitle || ('#' + s.row.contentId) }}</div>
          <div class="cell-sub">{{ s.row.contentTypeLabel }} · ID {{ s.row.contentId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="轮次" width="75" align="center">
        <template slot-scope="s">第 {{ s.row.round }} 轮</template>
      </el-table-column>
      <el-table-column label="结果" width="85" align="center">
        <template slot-scope="s">
          <el-tag :type="s.row.result === 'approve' ? 'success' : 'danger'" size="mini">{{ s.row.resultLabel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态变化" width="160">
        <template slot-scope="s">{{ s.row.beforeStatus }} → {{ s.row.afterStatus }}</template>
      </el-table-column>
      <el-table-column label="审核人" width="170">
        <template slot-scope="s">
          <div>{{ s.row.reviewerName || '未填写' }}</div>
          <div class="cell-sub">{{ s.row.reviewerPhone || '-' }} · ID {{ s.row.reviewerId }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="驳回原因" min-width="160">
        <template slot-scope="s"><span class="reason">{{ s.row.reason || '-' }}</span></template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right" align="center">
        <template slot-scope="s">
          <el-button type="text" @click="showDetail(s.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="审核日志详情" :visible.sync="detailVisible" width="520px">
      <div v-if="current" class="detail">
        <div class="d-row"><span class="d-k">审核时间</span><span class="d-v">{{ formatTime(current.createdAt) }}</span></div>
        <div class="d-row">
          <span class="d-k">审核结果</span>
          <span class="d-v">
            <el-tag :type="current.result === 'approve' ? 'success' : 'danger'" size="mini">{{ current.resultLabel }}</el-tag>
            <span class="d-round">（第 {{ current.round }} 轮）</span>
          </span>
        </div>
        <div class="d-row"><span class="d-k">状态变化</span><span class="d-v">{{ current.beforeStatus }} → {{ current.afterStatus }}</span></div>
        <div class="d-row">
          <span class="d-k">审核人</span>
          <span class="d-v">{{ current.reviewerName || '未填写' }}（{{ current.reviewerPhone || '-' }}，用户 ID {{ current.reviewerId }}）</span>
        </div>
        <div class="d-row">
          <span class="d-k">审核内容</span>
          <span class="d-v">{{ current.contentTypeLabel }} · ID {{ current.contentId }}<br><b>{{ current.contentTitle || '（内容已删除）' }}</b></span>
        </div>
        <div class="d-row" v-if="current.reason">
          <span class="d-k">驳回原因</span>
          <span class="d-v reason-text">{{ current.reason }}</span>
        </div>
        <div class="d-tip">该记录由系统自动写入，不可修改、不可删除，用于追责留档。</div>
      </div>
    </el-dialog>

    <div class="pager">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="total"
        :page-size="query.pageSize" :current-page="query.page" :page-sizes="[20, 50, 100]"
        @size-change="onSizeChange" @current-change="onPageChange" />
    </div>

    <div v-if="!loading && !rows.length" class="empty">还没有审核日志，审核人员在小程序端完成一次审核后会出现在这里。</div>
  </section>
</template>
<script>
import request from '@/api/request';
export default {
  data() {
    return {
      rows: [],
      total: 0,
      loading: false,
      reviewerOptions: [],
      range: null,
      detailVisible: false,
      current: null,
      query: { type: 'all', result: 'all', reviewerId: '', keyword: '', from: '', to: '', page: 1, pageSize: 20 }
    };
  },
  created() {
    this.loadReviewers();
    this.load();
  },
  methods: {
    formatTime(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    showDetail(row) {
      this.current = row;
      this.detailVisible = true;
    },
    async load() {
      this.loading = true;
      try {
        const params = Object.assign({}, this.query);
        Object.keys(params).forEach((k) => {
          if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
        });
        const r = await request.get('/admin/reviewers/logs', { params });
        this.rows = r.data.list || [];
        this.total = r.data.total || 0;
        this.query.page = r.data.page || 1;
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) || '审核日志加载失败');
      } finally { this.loading = false; }
    },
    async loadReviewers() {
      try {
        const r = await request.get('/admin/reviewers/logs/reviewers');
        this.reviewerOptions = r.data || [];
      } catch (e) { this.reviewerOptions = []; }
    },
    onRangeChange(value) {
      this.query.from = value && value[0] ? value[0] : '';
      this.query.to = value && value[1] ? value[1] : '';
      this.reload();
    },
    onPageChange(page) { this.query.page = page; this.load(); },
    onSizeChange(size) { this.query.pageSize = size; this.query.page = 1; this.load(); },
    reload() { this.query.page = 1; this.load(); },
    reset() {
      this.range = null;
      this.query = { type: 'all', result: 'all', reviewerId: '', keyword: '', from: '', to: '', page: 1, pageSize: 20 };
      this.load();
    }
  }
};
</script>
<style scoped>
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.toolbar h1 { margin: 0; color: #24384b; font-size: 22px; }
.toolbar p { margin: 6px 0 0; color: #8493a1; font-size: 13px; }
.filters { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.cell-title { color: #24384b; }
.cell-sub { margin-top: 2px; color: #98a4b0; font-size: 12px; }
.reason { color: #c0563f; }
.pager { display: flex; justify-content: flex-end; margin-top: 16px; }
.empty { margin-top: 18px; color: #8493a1; font-size: 13px; text-align: center; }
.detail .d-row { display: flex; gap: 14px; padding: 9px 0; border-bottom: 1px solid #f0f3f5; }
.detail .d-k { flex: none; width: 76px; color: #98a4b0; font-size: 13px; }
.detail .d-v { flex: 1; min-width: 0; color: #24384b; font-size: 13px; line-height: 1.6; }
.d-round { margin-left: 6px; color: #98a4b0; font-size: 12px; }
.reason-text { color: #c0563f; }
.d-tip { margin-top: 14px; color: #b3bec8; font-size: 12px; }
</style>
